/*
 * Kivora "Pairs well with" add-on (snippets/kv-pairs.liquid, block `kv_pairs` in main-product).
 * Adds the picked product to the cart with one /cart/add.js call and re-renders Dawn's cart drawer from
 * the response, the same way the bundle picker does (assets/kv-bundle.js).
 */
(() => {
  if (customElements.get('kv-pairs')) return;

  class KvPairs extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-kvpw-add]');
      this.variant = this.querySelector('[data-kvpw-variant]');
      this.price = this.querySelector('[data-kvpw-price]');
      this.status = this.querySelector('[data-kvpw-status]');
      this.busy = false;
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      if (this.button) this.button.addEventListener('click', this.onClick);
      if (this.variant && this.variant.tagName === 'SELECT') this.variant.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
      if (this.variant && this.variant.tagName === 'SELECT') this.variant.removeEventListener('change', this.onChange);
    }

    onChange() {
      const option = this.variant.selectedOptions && this.variant.selectedOptions[0];
      if (option && option.dataset.price && this.price) this.price.textContent = option.dataset.price;
      this.say('');
    }

    say(message) {
      if (!this.status) return;
      this.status.hidden = !message;
      this.status.textContent = message || '';
    }

    onClick() {
      if (this.busy || !this.variant) return;
      const id = Number(this.variant.value);
      if (!id) return;

      const drawer = document.querySelector('cart-drawer');
      const canRender =
        drawer && typeof drawer.getSectionsToRender === 'function' && typeof drawer.renderContents === 'function';
      const body = { items: [{ id, quantity: 1 }] };
      if (canRender) {
        body.sections = drawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(this.button);
      }

      this.busy = true;
      this.say('');
      this.button.setAttribute('aria-disabled', 'true');
      this.button.classList.add('is-loading');
      const done = () => {
        this.busy = false;
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('is-loading');
      };

      const routes = window.routes || {};
      fetch(`${routes.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
          done();
          if (!ok || (data && data.status)) {
            this.say((data && (data.description || data.message)) || this.dataset.msgError);
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kv-pairs', productVariantId: id, cartData: data });
          }
          if (canRender && data && data.sections) {
            try {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
              return;
            } catch (error) {
              console.error('[kv-pairs] drawer render failed', error);
            }
          }
          this.say(this.dataset.msgAdded);
        })
        .catch((error) => {
          console.error('[kv-pairs]', error);
          done();
          this.say(this.dataset.msgError);
        });
    }
  }

  customElements.define('kv-pairs', KvPairs);
})();
